import React from 'react';

// ASSETS
import { Avatar } from './assets/Avatar';
import { AlertIcon } from './assets/AlertIcon';

// INTERFACES
import { IProfile } from '../../interfaces/Profile.interface';

// STYLES
import { Container, UserName, AlertContainer } from './styles';

const Profile: React.FC<IProfile> = ({ username }: IProfile) => {
  return (
    <Container>
      <UserName>{username}</UserName>
      <Avatar />
      <AlertContainer>
        <AlertIcon />
      </AlertContainer>
    </Container>
  );
};

export default Profile;
